import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100svh;
  padding-top: 32px;
`;

export const Header = styled(Box)`
  display: flex;
  max-width: 610px;
  width: 100%;
  flex-direction: column;
`;

export const IconWrapper = styled(Box)`
  cursor: pointer;
  width: fit-content;
`;

export const RatingWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const Footer = styled(Box)`
  display: flex;
  height: 334px;
  width: 100%;
  flex-direction: column;
  background-color: green;
  gap: 50px;
`;

export const ImageWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  max-width: 610px;
  width: 100%;
`;

export const ActionWrapper = styled(Box)`
  display: flex;
  max-width: 610px;
  width: 100%;
`;

export const Title = styled(Typography)`
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 111.111% */
`;

export const SubTitle = styled(Typography)`
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 155.556% */
`;
